import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Tables from "layouts/tables";
import { useEffect, useState } from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  useGetBeauticiansQuery,
  useBeauticianStatusMutation,
  useDeleteBeauticianMutation,
} from "slices/beautyApp/beauticianSlice";
import { useSelector } from "react-redux";
import { hasActionAccess } from "utility";
import { useGetAllLocationQuery } from "slices/locationApi";
import {
  useGetLocationsQuery,
  useDeleteLocationMutation,
} from "slices/common/locationSlice";
import { Box } from "@mui/system";
import ExportCSV from "utility/exportCsv";
function Beauticians() {
  const pagelocation = 1;
  const limitlocation = 100;
  const naviagte = useNavigate();
  const [type, setType] = useState("all");
  const [cityId, setSelectedCity] = useState("");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const auth = useSelector((state) => state.auth.auth?.user);
  const [statusMap, setStatusMap] = useState({});
  const [statusUpdate] = useBeauticianStatusMutation();
  const [del] = useDeleteBeauticianMutation();
  const {
    data: cityData,
    isLoading: cityLoading,
    error: errorLoading,
    refetch: refetchLoading,
  } = useGetLocationsQuery({ pagelocation, limitlocation, search });

  const { data, isLoading, refetch } = useGetBeauticiansQuery({
    page,
    limit,
    search,
    type,
    cityId,
  });

  useEffect(() => {}, [page, limit, search, type]);

  console.log("data", data);

  const col = [
    {
      display: "Image",
      key: "image",
      type: "image",
      style: {
        borderRadius: "50%",
        height: "80px",
        width: "80px",
        objectFit: "cover",
        boxShadow: "0px 4px 10px rgba(0,0,0,0.15)",
      },
    },
    { display: "Name", key: "name", type: "display" },
    { display: "Email", key: "email", type: "display" },
    { display: "Mobiile", key: "mobile", type: "display" },
    { display: "Register From", key: "regFrom", type: "display" },
    // {
    //   display: "First Approval",
    //   key: "firstApproval",
    //   type: "display",
    //   render: (row) =>
    //     row.status === "inactive" ? (
    //       <button
    //         onClick={() => handleStatusChange(row._id, "mid-active")}
    //         className="px-3 py-1 bg-green-500 text-white rounded-lg hover:bg-green-600"
    //       >
    //         Approve
    //       </button>
    //     ) : row.status === "mid-active" || row.status === "active" ? (
    //       <span className="text-green-600 font-semibold">Approved</span>
    //     ) : row.status === "blocked" ? (
    //       <span className="text-red-500 font-semibold">Blocked</span>
    //     ) : row.status === "deleted" ? (
    //       <span className="text-gray-400 font-semibold">Deleted</span>
    //     ) : (
    //       <span className="text-gray-500">Pending</span>
    //     ),
    // },
    {
      display: "Final Approval",
      key: "finalApproval",
      type: "display",
      render: (row) => (
        <select
          value={row.status}
          onChange={(e) => handleStatusChange(row._id, e.target.value)}
          className="px-2 py-1 border rounded-lg"
        >
          <option value="pending">Pending First Approval</option>
          <option value="mid-active">Mid Active</option>
          <option value="active">Approved</option>
          <option value="blocked">Blocked</option>
          <option value="deleted">Deleted</option>
        </select>
      ),
    },
  ];

  const canEdit = hasActionAccess(auth, "Beauty App", "Beautician", "view");
  const canDelete = hasActionAccess(auth, "Beauty App", "Beautician", "delete");

  if (canEdit || canDelete) {
    col.push({
      display: "Actions",
      key: "edit",
      type: "action",
      render: (row, onEdit, handleDelete) => (
        <>
          {canEdit && <Button onClick={() => onView(row)}>View</Button>}
          {canDelete && (
            <Button onClick={() => handleDelete(row._id)}>Delete</Button>
          )}
        </>
      ),
    });
  }

  const handleStatusChange = async (id, value) => {
    await statusUpdate({ id, status: value }).unwrap();
    refetch();
  };

  const handleSearchChange = (value) => {
    setSearch(value);
    setPage(1);
  };

  const changePage = (newPage, newLimit) => {
    const apiPage = newPage + 1; // MUI is 0-based, API is 1-based
    setPage(apiPage);
    setLimit(newLimit);
  };

  const onView = (row) => {
    naviagte(`/beauty-app/beauticians/beautician/${row._id}`);
  };

  const handleAdd = () => {
    naviagte("/beauty-app/beauticians/add-beautician");
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this beautician?")) {
      await del(id).unwrap();
      refetch();
    }
  };

  // const onTabClick = async (item, index) => {
  //   if (index === 0) {
  //     setType("");
  //   } else {
  //     setType(item.value);
  //   }
  // };

  const onTabClick = (index, item) => {
    if (index === 0) {
      setType("");
    } else {
      setType(item.value);
    }
    refetch();
  };
  const canAdd = hasActionAccess(auth, "Beauty App", "Beautician", "add");

  const csvColumns = [
    { label: "Name", key: "name" },
    { label: "Email", key: "email" },
    { label: "Mobile", key: "mobile" },
    { label: "Gender", key: "gender" },
    { label: "Source", key: "regFrom" },
    { label: "Referral Code", key: "referralCode" },
    { label: "Status", key: "status" },
    { label: "Created At", key: "created" },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <Box sx={{ display: "flex", justifyContent: "flex-start", mb: 2 }}>
        {canAdd && (
          <Button onClick={handleAdd} style={{ background: "#fff" }}>
            Add Beautician
          </Button>
        )}
        <ExportCSV
          data={data?.data?.data}
          columns={csvColumns}
          fileName="Beauticians List"
        />
      </Box>
      <Tables
        tabs={[
          { name: "New", value: "new" },
          { name: "Active", value: "active" },
          { name: "In-active", value: "in-active" },
          { name: "Blocked", value: "blocked" },
        ]}
        title={"Beauticians"}
        filterData={{
          data: cityData?.data?.data,
          for: "city",
          labelKey: "cityName",
          onChange: (cityId) => {
            setSelectedCity(cityId); // store city id
            refetch();

            // fetchUsers({ cityId });       // API call / filter logic
          },
        }}
        handleSearch={handleSearchChange}
        totalPages={data?.data?.pagination?.totalPages}
        data={data?.data?.data}
        columns={col}
        changePage={changePage}
        onEdit={onView}
        handleDelete={handleDelete}
        onTabClick={onTabClick}
        currentPage={page}
        rowsPerPage={limit}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default Beauticians;
